import { gql } from '@apollo/client';
import { SubscriptionInfoShared } from '@retainerclub/shared-api';
import PatientInfoPublic from './PatientInfo';

const AccountInfoPublic = gql`
  fragment AccountInfoPublic on Account {
    id
    users {
      id
      firstName
      lastName
      email
      phone
      imageUrl
      state
      acceptTerms
      acceptTermsAt
      acceptSms
      acceptMarketing
      acceptSmsAt
      acceptMarketingAt
      createdAt
    }
    accountAddresses {
      id
      address
      address2
      city
      region
      postalCode
      country
      isBilling
      isShipping
      isDefault
      accountId
    }
    referrals {
      id
      state
      customerOptions
      accountId
      isFreeTrial
      hexCode
      source
    }
    patients {
      ...PatientInfoPublic
      subscriptions {
        ...SubscriptionInfoShared
      }
    }
    orders {
      id
      hexCode
      createdAt
      total
      state
      orderItems {
        id
        name
        quantity
        total
        product {
          id
          featuredImage
          description
        }
      }
    }
    accountCreditCards {
      id
      nameOnCard
      maskedNumber
      brand
      defaultCard
      expiryMonth
      expiryYear
      billingAddress
      createdAt
      updatedAt
    }
    partnerLocationId
    partnerOrganizationId
  }
  ${PatientInfoPublic}
  ${SubscriptionInfoShared}
`;

export default AccountInfoPublic;
